module.exports = __webpack_public_path__ + "static/media/univ-edited.507e6342.jpg";